import DateHelper from '@/lib/DateHelper'

const ClubLayout = () => import('@/components/Dashboard/Views/Club/Layout/ClubLayout.vue')
const ClubUsersLayout = () =>
  import('@/components/Dashboard/Views/Club/Views/ClubUsers/Layout/ClubUsersLayout.vue')
const ClubSponsorsLayout = () =>
  import('@/components/Dashboard/Views/Club/Views/ClubSponsors/Layout/ClubSponsorsLayout.vue')
const ClubAddMatchesLayout = () =>
  import('@/components/Dashboard/Views/Club/Views/ClubAddMatches/Layout/ClubAddMatchesLayout.vue')
const WeekMatchesLayout = () =>
  import('@/components/Dashboard/Views/Club/Views/WeekMatches/Layout/WeekMatchesLayout.vue')
const MatchLayout = () =>
  import('@/components/Dashboard/Views/Club/Views/WeekMatches/Views/Match/Layout/MatchLayout.vue')
const DashboardLayout = () => import('@/components/Dashboard/Layout/DashboardLayout.vue')

const ClubUsers = () => import('@/components/Dashboard/Views/Club/Views/ClubUsers/ClubUsers')
const ClubSponsors = () =>
  import('@/components/Dashboard/Views/Club/Views/ClubSponsors/ClubSponsors')
const ClubAddMatches = () =>
  import('@/components/Dashboard/Views/Club/Views/ClubAddMatches/ClubAddMatches')
const WeekMatches = () => import('@/components/Dashboard/Views/Club/Views/WeekMatches/WeekMatches')
const Match = () => import('@/components/Dashboard/Views/Club/Views/WeekMatches/Views/Match/Match')

function week() {
  return `${DateHelper.getWeekNumber()}`
}
function year() {
  return `${DateHelper.getYearNumber()}`
}

export default {
  path: 'club/:clubId',
  component: DashboardLayout,
  props: true,
  children: [
    {
      path: '',
      name: 'Club',
      component: ClubLayout,
      redirect: `/club/:clubId/${year()}/${week()}`,
      props: true,
      children: [
        {
          path: 'users',
          component: ClubUsersLayout,
          props: true,
          children: [
            {
              path: '',
              name: 'ClubUsers',
              component: ClubUsers,
              props: true,
              children: [],
            },
          ],
        },
        {
          path: 'sponsors',
          component: ClubSponsorsLayout,
          props: true,
          children: [
            {
              path: '',
              name: 'ClubSponsors',
              component: ClubSponsors,
              props: true,
              children: [],
            },
          ],
        },
        {
          path: 'add-matches/:year/:week',
          component: ClubAddMatchesLayout,
          props: true,
          children: [
            {
              path: '',
              name: 'ClubAddMatches',
              component: ClubAddMatches,
              props: true,
              children: [],
            },
          ],
        },
        {
          path: ':year/:week',
          component: WeekMatchesLayout,
          props: true,
          children: [
            {
              path: '',
              name: 'WeekMatches',
              component: WeekMatches,
              props: true,
            },
            {
              path: 'match/:matchId',
              component: MatchLayout,
              props: true,
              children: [
                {
                  path: '',
                  name: 'Match',
                  component: Match,
                  props: true,
                },
              ],
            },
          ],
        },
      ],
    },
  ],
}
